import { ReactNode } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import "./sortableItem.css"
import { useDragHaptics } from "../../hooks/useDragHaptics";

export const SortableItem = ({ id, children }: { id: string, children: ReactNode }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const { onPressStart, onPressEnd } = useDragHaptics(200);

  return (
    <li
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        userSelect: "none",
        touchAction: "pan-y",
        cursor: "grab",
        opacity: isDragging ? 0 : 1
      }}
      className="no-select"
      ref={setNodeRef}
      onPointerUp={onPressEnd}
      onPointerCancel={onPressEnd}
      onTouchStart={onPressStart}
      onTouchEnd={onPressEnd}
      {...attributes}
      {...listeners}
    >
      {children}
    </li>
  );
};

export default SortableItem;
